
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import "./UserActivity.css";

const UserActivity = () => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card mb-3">
                    <div className="card-header">
                        <h5 className="mb-0">AudiTrails</h5>
                    </div>
                </div>
            </div>
            <div className="col-lg-3">
                <div className="card">
                    <div className="card-block">
                        <span className="f-18">Timeline</span>
                        <div className="form-group mt-3 mb-2">
                            <label className="form-label">From</label>
                            <input type="date" className="form-control input-me" />
                        </div>
                        <div className="form-group mb-2">
                            <label className="form-label">To</label>
                            <input type="date" className="form-control input-me" />
                        </div>
                        <span className="f-18 mt-4 mb-2 d-block">Actions</span>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="update" />
                            <label class="form-label f-14" for="update">
                                Update
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="insert" />
                            <label class="form-label f-14" for="insert">
                                Insert
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="deleted" />
                            <label class="form-label f-14" for="deleted">
                                Deleted
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="view" />
                            <label class="form-label f-14" for="view">
                                View
                            </label>
                        </div>
                        <span className="f-18 mb-2 mt-3 d-block">Approvals</span>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="accounts" />
                            <label class="form-label f-14" for="accounts">
                                Accounts
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="account_group" />
                            <label class="form-label f-14" for="account_group">
                                Account Groups
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="account_sections" />
                            <label class="form-label f-14" for="account_sections">
                                Account Sections
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="admin" />
                            <label class="form-label f-14" for="admin">
                                Admin
                            </label>
                        </div>
                        <span className="f-18 mb-2 mt-3 d-block">Account Access</span>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="logins" />
                            <label class="form-label f-14" for="logins">
                                Logins
                            </label>
                        </div>
                        <button className="btn btn-danger btn-sm mt-3">Reset</button>
                    </div>
                </div>
            </div>
            <div className="col-lg-9">
                <div className="card">
                    <div className="m-5">
                        <div className="row pt-3 pb-3 border-top border-bottom user_activity align-items-center position-relative">
                            <div className="col-lg-2 text-start">
                                <p className="m-0">09:48:56 PM</p>
                            </div>
                            <div className="col-lg-1 text-center position-relative">
                                <span className="today-msg">Today</span>            
                                <span className="btn rounded-circle bg-white text-primary">
                                    <FontAwesomeIcon icon={faEye} className="f-14" />    
                                </span>
                            </div>
                            <div className="col-lg-9">
                                <div className="align-top">
                                    <div className=" align-top m-l-10">
                                        <a href="#!">
                                            <div className="align-middle">
                                                <img src="./profile.jpg" className="rounded-circle img-30 align-top mr-10" />
                                                <div className="d-inline-block width73 text-capitalize">
                                                    <span>Anthony Johnston 
                                                        <span className="f-w-600"> VIEW </span>   
                                                         View Profile Application Users
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row pt-3 pb-3 border-top border-bottom user_activity align-items-center position-relative">
                            <div className="col-lg-2 text-start">
                                <p className="m-0">09:48:56 PM</p>
                            </div>
                            <div className="col-lg-1 text-center position-relative">
                                {/* <span className="today-msg">Today</span>             */}
                                <span className="btn rounded-circle bg-white text-primary">
                                    <FontAwesomeIcon icon={faEye} className="f-14" />    
                                </span>
                            </div>
                            <div className="col-lg-9">
                                <div className="align-top">
                                    <div className=" align-top m-l-10">
                                        <a href="#!">
                                            <div className="align-middle">
                                                <img src="./profile.jpg" className="rounded-circle img-30 align-top mr-10" />
                                                <div className="d-inline-block width73 text-capitalize">
                                                    <span>Anthony Johnston 
                                                        <span className="f-w-600"> VIEW </span>   
                                                         View Profile Application Users
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row pt-3 pb-3 border-top border-bottom user_activity align-items-center position-relative">
                            <div className="col-lg-2 text-start">
                                <p className="m-0">09:48:56 PM</p>
                            </div>
                            <div className="col-lg-1 text-center position-relative">
                                {/* <span className="today-msg">Today</span>             */}
                                <span className="btn rounded-circle bg-white text-primary">
                                    <FontAwesomeIcon icon={faEye} className="f-14" />    
                                </span>
                            </div>
                            <div className="col-lg-9">
                                <div className="align-top">
                                    <div className=" align-top m-l-10">
                                        <a href="#!">
                                            <div className="align-middle">
                                                <img src="./profile.jpg" className="rounded-circle img-30 align-top mr-10" />
                                                <div className="d-inline-block width73 text-capitalize">
                                                    <span>Anthony Johnston 
                                                        <span className="f-w-600"> VIEW </span>   
                                                         View Profile Application Users
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row pt-3 pb-3 border-top border-bottom user_activity align-items-center position-relative">
                            <div className="col-lg-2 text-start">
                                <p className="m-0">09:48:56 PM</p>
                            </div>
                            <div className="col-lg-1 text-center position-relative">
                                <span className="today-msg">Yesterday</span>            
                                <span className="btn rounded-circle bg-white text-primary">
                                    <FontAwesomeIcon icon={faEye} className="f-14" />    
                                </span>
                            </div>
                            <div className="col-lg-9">
                                <div className="align-top">
                                    <div className=" align-top m-l-10">
                                        <a href="#!">
                                            <div className="align-middle">
                                                <img src="./profile.jpg" className="rounded-circle img-30 align-top mr-10" />
                                                <div className="d-inline-block width73 text-capitalize">
                                                    <span>Anthony Johnston 
                                                        <span className="f-w-600"> VIEW </span>   
                                                         View Profile Application Users
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserActivity;